import React, { useState, useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import GetSurveysForProblems from "../queries/GetSurveysForProblems";
import Select from "react-select";
import Spinner from "./Spinner";
import writeXlsxFile from "write-excel-file";
import ErrorResponseRow from "./minorComponents/ErrorResponseRow";
import { useAppContext } from "../AppContext";
import DatePicker from "react-datepicker";

import {
  Table,
  Row,
  Col,
  Card,
  CardHeader,
  FormGroup,
  CardBody,
  Button,
} from "reactstrap";

const ErrorDataLog = () => {
  const { error, loading, data, refetch } = useQuery(GetSurveysForProblems, {
    variables: {
      survey_language: null,
      trial_type: null,
      survey_type: null,
    },
  });
  const [selectedLanguage, setSelectedLanguage] = useState({
    value: null,
    label: "None",
  });
  const [selectedTrialType, setSelectedTrialType] = useState({
    value: null,
    label: "None",
  });
  const [selectedSurveyType, setSelectedSurveyType] = useState({
    value: null,
    label: "None",
  });
  const dataToDisplay = useRef(null);
  const { displayToast, closeToast } = useAppContext();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const runRefetch = async () => {
      let variables;

      if (
        (!selectedLanguage || selectedLanguage.value === null) &&
        (!selectedTrialType || selectedTrialType.value === null) &&
        (!selectedSurveyType || selectedSurveyType.value === null)
      ) {
        variables = {
          survey_language: null,
          trial_type: null,
          survey_type: null,
        };
      } else {
        variables = {
          survey_language: selectedLanguage?.value ?? null,
          trial_type: selectedTrialType?.value ?? null,
          survey_type: selectedSurveyType?.value ?? null,
        };
      }

      dataToDisplay.current = null;
      setIsFetching(true);

      try {
        await refetch(variables);
      } finally {
        setIsFetching(false);
      }
    };

    runRefetch();
  }, [
    selectedLanguage,
    selectedTrialType,
    selectedSurveyType,
    refetch,
    startDate,
    endDate,
  ]);

  if (loading) return <Spinner />;
  if (error) {
    console.log("error:");
    console.log(error);
    return <p>Something Went Wrong...</p>;
  }

  const { surveys } = data;

  if (surveys.length !== 0) {
    if (dataToDisplay.current === null || dataToDisplay.current.length > 0)
      dataToDisplay.current = [];

    const startDateTimestamp = startDate ? startDate.getTime() : null;
    // const endDateTimestamp = endDate ? endDate.getTime() : null;
    // const endDateTimestamp = endDate ? new Date(new Date(endDate).setHours(23, 59, 59, 999)).getTime() : null;
    const endDateTimestamp = endDate
      ? new Date(endDate.setHours(23, 59, 59, 999)).getTime()
      : null;

    surveys.forEach((survey) => {
      if (survey.problems?.length === 0) return;

      // Find the index of the existing survey data by title
      let existingDataIndex = dataToDisplay.current.findIndex(
        (data) => data.title === survey.title,
      );

      let filteredProblems = survey.problems;

      if (startDateTimestamp !== null && endDateTimestamp !== null) {
        filteredProblems = survey.problems.filter((problem) => {
          // Convert created_date to a number if it's stored as a string
          const problemDateTimestamp = Number(problem.created_date);

          if (
            problem.id === "65deb40eca13bbb7f11c0339" ||
            problem.id === "65e1ed5c861c1b5ac47ea39b"
          ) {
            console.log(problem.content);
            const currentDate = new Date();

            const createdDate = new Date(parseInt(problem.created_date, 10));

            // console.log("currentDate: ", currentDate.getTime())
            // console.log("problemDateTimestamp: ", problemDateTimestamp)
            // console.log("startDateTimestamp: ", startDateTimestamp)
            // console.log("endDateTimestamp: ", endDateTimestamp)

            console.log("currentDate: ", currentDate);
            console.log("createdDate: ", new Date(createdDate).toString());
            console.log(
              "startDateTimestamp: ",
              new Date(startDateTimestamp).toString(),
            );
            console.log(
              "endDateTimestamp: ",
              new Date(endDateTimestamp).toString(),
            );
          }

          // Check if problem.created_date is within the start and end dates
          return (
            problemDateTimestamp >= startDateTimestamp &&
            problemDateTimestamp <= endDateTimestamp
          );
        });
      }

      if (existingDataIndex !== -1) {
        // Existing data found, update it directly
        console.log("it existed... ", survey);
        // Update problems by adding user information to each problem and then appending them to existing problems
        let existingData = dataToDisplay.current[existingDataIndex];
        const updatedProblems = filteredProblems.map((problem) => ({
          ...problem,
          user: survey.user.user_name,
          system: {
            pc_edge: survey.pc_edge,
            pc_chrome: survey.pc_chrome,
            pc_firefox: survey.pc_firefox,
            pc_other: survey.pc_other,
            mac_safari: survey.mac_safari,
            mac_chrome: survey.mac_chrome,
            mac_firefox: survey.mac_firefox,
            mac_other: survey.mac_other,
            ios_tablet: survey.ios_tablet,
            ios_smartphone: survey.ios_smartphone,
            ios_safari: survey.ios_safari,
            ios_edge: survey.ios_edge,
            ios_chrome: survey.ios_chrome,
            ios_firefox: survey.ios_firefox,
            ios_other: survey.ios_other,
            android_tablet: survey.android_tablet,
            android_smartphone: survey.android_smartphone,
            android_edge: survey.android_edge,
            android_chrome: survey.android_chrome,
            android_firefox: survey.android_firefox,
            android_other: survey.android_other,
            vpn: survey.vpn,
          },
        }));
        existingData.problems = [...existingData.problems, ...updatedProblems];
      } else {
        // Existing data not found, create new and push with user information included in each problem
        const newData = {
          title: survey.title,
          problems: filteredProblems.map((problem) => ({
            ...problem,
            user: survey.user.user_name,
            system: {
              pc_edge: survey.pc_edge,
              pc_chrome: survey.pc_chrome,
              pc_firefox: survey.pc_firefox,
              pc_other: survey.pc_other,
              mac_safari: survey.mac_safari,
              mac_chrome: survey.mac_chrome,
              mac_firefox: survey.mac_firefox,
              mac_other: survey.mac_other,
              ios_tablet: survey.ios_tablet,
              ios_smartphone: survey.ios_smartphone,
              ios_safari: survey.ios_safari,
              ios_edge: survey.ios_edge,
              ios_chrome: survey.ios_chrome,
              ios_firefox: survey.ios_firefox,
              ios_other: survey.ios_other,
              android_tablet: survey.android_tablet,
              android_smartphone: survey.android_smartphone,
              android_edge: survey.android_edge,
              android_chrome: survey.android_chrome,
              android_firefox: survey.android_firefox,
              android_other: survey.android_other,
              vpn: survey.vpn,
            },
          })),
        };
        dataToDisplay.current.push(newData);
      }
    });
  } else {
    dataToDisplay.current = [];
  }

  function displayProblems(data, dIndex) {
    return data.problems.flatMap((problem, pIndex) => [
      <tr key={`problem_${dIndex}_${pIndex}_info`}>
        <td>{problem.user}</td>
        <td>{problem.page_number}</td>
        <td>{problem.problem_type === "technical" ? "Technical" : "Other"}</td>
        <td style={{ whiteSpace: "normal" }}>{problem.content}</td>
      </tr>,
      <ErrorResponseRow
        dIndex={dIndex}
        pIndex={pIndex}
        problem={problem}
        key={`problem_${dIndex}_${pIndex}_response`}
      />,
    ]);
  }

  function displayData() {
    return dataToDisplay.current.map((data, dIndex) => {
      return (
        <React.Fragment key={`dataToDisplay_${dIndex}`}>
          <Table bordered striped>
            <thead>
              <tr>
                <th
                  scope="col"
                  style={{ backgroundColor: "lightgray" }}
                  colSpan={6}
                >
                  <div
                    className="d-flex justify-content-center font-weight-bold"
                    style={{
                      fontSize: ".85rem",
                    }}
                  >
                    {data.title}
                  </div>
                </th>
              </tr>
              <tr>
                <th scope="col" style={{ width: "1%" }}>
                  User ID
                </th>
                <th scope="col" style={{ width: "1%" }}>
                  Page #
                </th>
                <th scope="col" style={{ width: "1%" }}>
                  Type
                </th>
                <th scope="col">Problem Description/Where Encountered</th>
              </tr>
            </thead>
            <tbody>{displayProblems(data, dIndex)}</tbody>
          </Table>
        </React.Fragment>
      );
    });
  }

  function generateClientExcel() {
    let success =
      dataToDisplay.current !== null && dataToDisplay.current.length !== 0;

    const toast = {
      title: success ? "Success" : "Error",
      color: success ? "bg-success" : "bg-danger",
      icon: success ? "check-bold" : "fat-remove",
      message: success ? "XML is being generated" : "No data to place in XML",
    };

    displayToast(toast);

    setTimeout(() => {
      closeToast();
    }, 5000);

    if (!success) return;

    console.log("dataToDisplay: ", dataToDisplay.current);

    let tableData = [];

    dataToDisplay.current.forEach((data, dIndex) => {
      // objects.push(data.problems);
      // schemas.push(schema)
      // sheets.push(data.title.replace(/^Course I, /, '').slice(0, 30));

      tableData.push([
        {
          value: data.title,
          span: 7,
          backgroundColor: "#484a5c",
          color: "#ffffff",
          align: "center",
          width: 82,
        },
      ]);

      tableData.push([
        {
          type: String,
          value: "Date",
          align: "center",
          width: 12,
          backgroundColor: "#a8aabd",
          color: "#ffffff",
        },
        {
          type: String,
          value: "Status",
          align: "center",
          width: 12,
          backgroundColor: "#a8aabd",
          color: "#ffffff",
        },
        {
          type: String,
          value: "ID",
          align: "center",
          width: 12,
          backgroundColor: "#a8aabd",
          color: "#ffffff",
        },
        {
          type: String,
          value: "Page #",
          align: "center",
          width: 12,
          backgroundColor: "#a8aabd",
          color: "#ffffff",
        },
        {
          type: String,
          value: "Type",
          align: "center",
          width: 12,
          backgroundColor: "#a8aabd",
          color: "#ffffff",
        },
        {
          type: String,
          value: "Problem Description/Where Encountered",
          width: 20,
          backgroundColor: "#a8aabd",
          color: "#ffffff",
        },
        {
          type: String,
          value: "Response",
          align: "center",
          width: 12,
          backgroundColor: "#a8aabd",
          color: "#ffffff",
        },
      ]);

      data.problems.forEach((problem, pIndex) => {
        tableData.push([
          {
            type: Date,
            format: "MM/DD/YYYY HH:mm:ss",
            value: problem.created_date
              ? new Date(parseInt(problem.created_date, 10))
              : new Date(),
            width: 20,
          },
          {
            type: String,
            value: problem.status ? problem.status : "None",
            width: 20,
          },
          {
            type: String,
            value: problem.user,
            align: "center",
            width: 12,
          },
          {
            type: Number,
            value: problem.page_number,
            align: "center",
            width: 12,
          },
          {
            type: String,
            value:
              problem.problem_type.charAt(0).toUpperCase() +
              problem.problem_type.slice(1),
            align: "center",
            width: 12,
          },
          {
            type: String,
            value: problem.content,
            wrap: true,
            width: 20,
          },
          {
            type: String,
            value: problem.response ? problem.response : "",
            width: 20,
          },
        ]);
      });
    });

    // Get the current date
    const currentDate = new Date();

    // Format the date as YYYY-MM-DD
    const formattedDate = currentDate.toISOString().split("T")[0]; // This will give you a string like "2023-04-01"

    // Create the filename by including the formatted date
    const fileName = `survey_errors_${formattedDate}.xlsx`;

    // Use the fileName in your writeXlsxFile function
    writeXlsxFile(tableData, {
      fileName: fileName,
    });
  }

  function getUserSystem(system) {
    const possibleDevices = [
      "pc_edge",
      "pc_chrome",
      "pc_firefox",
      "pc_other",
      "mac_safari",
      "mac_chrome",
      "mac_firefox",
      "mac_other",
      "ios_tablet",
      "ios_smartphone",
      "ios_safari",
      "ios_edge",
      "ios_chrome",
      "ios_firefox",
      "ios_other",
      "android_tablet",
      "android_smartphone",
      "android_edge",
      "android_chrome",
      "android_firefox",
      "android_other",
    ];

    const devicesFound = [];
    let vpnStatus = null;

    possibleDevices.forEach((device) => {
      if (system.hasOwnProperty(device) && system[device])
        devicesFound.push(device);
    });
    if (system.hasOwnProperty("vpn")) {
      vpnStatus = system["vpn"];
    }

    if (devicesFound.length === 0) {
      if (vpnStatus === null) {
        return "No devices reported, not even VPN status";
      } else {
        return "No devices reported, VPN: " + vpnStatus;
      }
    } else {
      let stringToReturn =
        "VPN: " + vpnStatus === null ? "Not Answered" : vpnStatus;

      devicesFound.forEach((device) => {
        stringToReturn = stringToReturn + "||" + device.replace("_", " ");
      });
      return stringToReturn;
    }
  }

  function generateTroubleLog() {
    let success =
      dataToDisplay.current !== null && dataToDisplay.current.length !== 0;

    const toast = {
      title: success ? "Success" : "Error",
      color: success ? "bg-success" : "bg-danger",
      icon: success ? "check-bold" : "fat-remove",
      message: success ? "XML is being generated" : "No data to place in XML",
    };

    displayToast(toast);

    setTimeout(() => {
      closeToast();
    }, 5000);

    if (!success) return;

    console.log("dataToDisplay: ", dataToDisplay.current);

    let tableData = [];
    tableData.push([
      {
        type: String,
        value: "Date",
        align: "center",
        width: 12,
        backgroundColor: "#a8aabd",
      },
      {
        type: String,
        value: "Status",
        align: "center",
        width: 12,
        backgroundColor: "#a8aabd",
      },
      {
        type: String,
        value: "Survey",
        align: "center",
        width: 12,
        backgroundColor: "#a8aabd",
      },
      {
        type: String,
        value: "ID",
        align: "center",
        width: 12,
        backgroundColor: "#a8aabd",
      },
      {
        type: String,
        value: "Page #",
        align: "center",
        width: 12,
        backgroundColor: "#a8aabd",
      },
      {
        type: String,
        value: "Type",
        align: "center",
        width: 12,
        backgroundColor: "#a8aabd",
      },
      {
        type: String,
        value: "Reported System(s)",
        align: "center",
        width: 12,
        backgroundColor: "#a8aabd",
      },
      {
        type: String,
        value: "Problem Description/Where Encountered",
        width: 20,
        backgroundColor: "#a8aabd",
      },
      {
        type: String,
        value: "Response",
        align: "center",
        width: 12,
        backgroundColor: "#a8aabd",
      },
    ]);

    dataToDisplay.current.forEach((data, dIndex) => {
      data.problems.forEach((problem, pIndex) => {
        tableData.push([
          {
            type: Date,
            format: "MM/DD/YYYY HH:mm:ss",
            value: problem.created_date
              ? new Date(parseInt(problem.created_date, 10))
              : new Date(),
            width: 20,
          },
          {
            type: String,
            value: problem.status ? problem.status : "None",
            width: 20,
          },
          {
            type: String,
            value: data.title,
            width: 20,
          },
          {
            type: String,
            value: problem.user,
            align: "center",
            width: 12,
          },
          {
            type: Number,
            value: problem.page_number,
            align: "center",
            width: 12,
          },
          {
            type: String,
            value:
              problem.problem_type.charAt(0).toUpperCase() +
              problem.problem_type.slice(1),
            align: "center",
            width: 12,
          },
          {
            type: String,
            value: getUserSystem(problem.system),
            align: "center",
            width: 12,
          },
          {
            type: String,
            value: problem.content,
            wrap: true,
            width: 20,
          },
          {
            type: String,
            value: problem.response ? problem.response : "",
            width: 20,
          },
        ]);
      });
    });

    // Get the current date
    const currentDate = new Date();

    // Format the date as YYYY-MM-DD
    const formattedDate = currentDate.toISOString().split("T")[0]; // This will give you a string like "2023-04-01"

    // Create the filename by including the formatted date
    const fileName = `trouble_log_${formattedDate}.xlsx`;

    // Use the fileName in your writeXlsxFile function
    writeXlsxFile(tableData, {
      fileName: fileName,
    });
  }

  return (
    <>
      <Button color="primary" onClick={() => generateClientExcel()}>
        Create Client Excel
      </Button>
      <Button color="primary" onClick={() => generateTroubleLog()}>
        Create Trouble Log
      </Button>
      <Card className="bg-secondary shadow">
        <CardHeader className="bg-white border-0">
          <Row className="align-items-center">
            <Col sm="6" lg="2">
              <FormGroup>
                <label className="form-control-label" htmlFor="input-language">
                  Language
                </label>
                <Select
                  value={selectedLanguage}
                  onChange={(selectedLanguage) => {
                    setSelectedLanguage(selectedLanguage);
                  }}
                  options={[
                    {
                      value: null,
                      label: "None",
                    },
                    {
                      value: "arabic",
                      label: "Arabic",
                    },
                    {
                      value: "korean",
                      label: "Korean",
                    },
                    {
                      value: "russian",
                      label: "Russian",
                    },
                  ]}
                  className="form-control-alternative"
                  id="input-language"
                />
              </FormGroup>
            </Col>
            <Col sm="6" lg="2">
              <FormGroup>
                <label className="form-control-label" htmlFor="input-trial">
                  Trial Type
                </label>
                <Select
                  value={selectedTrialType}
                  onChange={(selectedTrialType) => {
                    setSelectedTrialType(selectedTrialType);
                  }}
                  options={[
                    {
                      value: null,
                      label: "None",
                    },
                    {
                      value: "individual",
                      label: "Individual",
                    },
                    {
                      value: "group",
                      label: "Group",
                    },
                  ]}
                  className="form-control-alternative"
                  id="input-trial"
                />
              </FormGroup>
            </Col>
            <Col sm="6" lg="2">
              <FormGroup>
                <label className="form-control-label" htmlFor="input-survey">
                  Survey Type
                </label>
                <Select
                  value={selectedSurveyType}
                  onChange={(selectedSurveyType) => {
                    setSelectedSurveyType(selectedSurveyType);
                  }}
                  options={[
                    {
                      value: null,
                      label: "None",
                    },
                    {
                      value: "imi",
                      label: "IMI",
                    },
                    {
                      value: "introduction",
                      label: "Introduction",
                    },
                    {
                      value: "assessment",
                      label: "Assessment",
                    },
                    {
                      value: "posttest",
                      label: "Posttest",
                    },
                  ]}
                  className="form-control-alternative"
                  id="input-survey"
                />
              </FormGroup>
            </Col>
            <Col sm="6" lg="2">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="input-start-date"
                >
                  Start Date
                </label>
                <DatePicker
                  id="input-start-date"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  isClearable={true}
                  placeholderText="Start Date"
                />
              </FormGroup>
            </Col>
            <Col sm="6" lg="2">
              <FormGroup>
                <label className="form-control-label" htmlFor="input-end-date">
                  End Date
                </label>
                <DatePicker
                  id="input-end-date"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  isClearable={true}
                  placeholderText="End Date"
                />
              </FormGroup>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className="p-0">
          {dataToDisplay.current !== null &&
          dataToDisplay.current.length > 0 ? (
            <>
              <div className="d-flex justify-content-center py-2 w-100 font-weight-bold table-dark">
                Course II
              </div>
              <div className="table-responsive">{displayData()}</div>
            </>
          ) : isFetching ? (
            <div className="d-flex flex-column p-5 my-5 h-100 w-100 justify-content-center align-items-center">
              <Spinner />
              <h3 className="text-muted mt-3">Loading results...</h3>
            </div>
          ) : (
            <div className="d-flex flex-column p-5 my-5 h-100 w-100 justify-content-center align-items-center">
              <h1>
                <i className="ni ni-bell-55 text-muted" />
              </h1>
              <h3 className="text-muted">
                Please select what you'd like to view
              </h3>
            </div>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default ErrorDataLog;
